<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <UNotifications :ui="{ width: 'w-60 mx-4' }" />
  </div>
</template>
